import { PropsWithChildren } from 'react'

export function Layout({
  centered = false,
  ...props
}: PropsWithChildren<{ centered?: boolean }>) {
  return (
    <div
      className={`bg-gray-100 h-full w-full justify-center ${
        centered ? 'items-center flex h-screen' : ''
      }`}
    >
      <div
        className="mx-auto py-12 sm:px-6  md:px-8 lg:px-40 xl:px-64"
        {...props}
      />
    </div>
  )
}
